// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import SimpleScrollbar from 'simple-scrollbar'
import Siema from 'siema';


function siemaInitSpeedup() {
  class mySiemaWithDots extends Siema {
    addDots() {
      this.dots = document.createElement('div');
      this.dots.classList.add('dots');
      for(let i = 0; i < this.innerElements.length; i++) {
        const dot = document.createElement('a');
        dot.classList.add('dot');
        dot.addEventListener('click', () => {
          this.goTo(i);
        })
        this.dots.appendChild(dot);
      }
      this.selector.parentNode.insertBefore(this.dots, this.selector.nextSibling);
    }
    updateDots() {
      for(let i = 0; i < this.dots.querySelectorAll('a').length; i++) {
        const addOrRemove = this.currentSlide === i ? 'add' : 'remove';
        this.dots.querySelectorAll('a')[i].classList[addOrRemove]('active');
      }
    }
  }
  const mySiemaWithDotsSpeedup = new mySiemaWithDots({
    selector: '.news-slider',
    loop: true,
    onInit: function(){
      this.addDots();
      this.updateDots();
    },
    onChange: function(){
      this.updateDots()
    },
  });
  //setInterval(() => mySiemaWithDotsSpeedup.next(), 5000);
  document.querySelector('.prev').addEventListener('click', () => mySiemaWithDotsSpeedup.prev());
  document.querySelector('.next').addEventListener('click', () => mySiemaWithDotsSpeedup.next());
}
window.addEventListener("load", function(){
  var isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
  if (isMobile) {
    siemaInitSpeedup()
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/home.js